module.exports = __webpack_public_path__ + "png/four_of_kind.png?2f98f247cfbd615d259b2c291568760a";